<template>
<div class="main">
  <div id="card" class="card">
    <h6 class="card-header">Technicians</h6>
    <div class="card-body prog-container">
      <b-table responsive ref="table" :sort-by="'name'" :items="items" :fields="fields">

        <template slot="name" slot-scope="row">
            {{row.item.fname+" "+row.item.lname}}
        </template>

        <template slot="roles" slot-scope="row">
            <b-button v-for="role in row.item.roles" size='sm' class="badge" variant="info">{{role.role}}</b-button>
        </template>

        <template slot="locations" slot-scope="row">
            <b-button v-for="loc in row.item.locations" size='sm' class="badge" style="padding:3%" variant="info">{{loc.name}}</b-button>
        </template>

        <template slot="actions" slot-scope="row">
            <b-button size='sm' variant="success" @click="update(row.item)">Update</b-button>
        </template>

      </b-table>
    </div>
  </div>
</div>
</template>
<script>
export default {
  created() {

    this.items = this.$store.state.technicians;
  },
  data: () => ({
      locations:[],
      roles:[],
      fields: [
        {key:'name',label:"Name"},
        {key:'username',label:'Username'},
        {key:'email',label:'Email'},
        {key:'roles',label:'Roles'},
        {key:'locations', label:'Locations'}
      ],
      items:[]

  }),
  methods: {

  }
}
</script>
<style lang="css" scoped>


.input{
  padding-left: 2%;
  padding-right: 5%;
  max-width: 300px;

}

.badge{
  padding: 2%;
  margin-left:1%;
  margin-right: 1%;
  margin-top: 1%;
}

.card-header{
  color: white;
  background-color:#2a2a2e;
}


button{
  padding-left: 8%;
  padding-right: 8%;
}

.main{
  width:100%;
  height: 100%;
}

.prog-container{
  min-height: 520px;
  overflow-y: auto;
}

#card{
  margin-left: 5%;
  margin-right: 5%;
  margin-top: 2%;
}

.card-header{
  text-align: left;
}


</style>
